module.exports = "https://la-static.vkplay.ru/promo/newstart/img/feature-openworld.3872cf62.jpg";